import type { ReactElement } from "react"
import UnderlineLinkAtm from "@onestore/hel/dist/components/atoms/UnderlineLinkAtm"
import type Theme from "@onestore/hel/dist/typings/theme"
import type { TermLink as TermLinkType } from "~/fragments/termLink"
import isEmpty from "~/lib/isEmpty"
import { getSummaryTerms } from "~/store/checkout-terms/selectors"
import { useAppSelector } from "~/store/hooks"

type TermLinkProps = Omit<TermLinkType["flatData"], "isDisplayInModal"> & {
  typography?: Theme.Typography
  emphasis?: Theme.Emphasis
}

const TermLink = ({
  text,
  title,
  termId,
  typography,
  emphasis,
}: TermLinkProps): ReactElement<TermLinkProps> | null => {
  const terms = useAppSelector(getSummaryTerms)

  const searchedTerm = terms.find((term) => term.id === termId)

  if (isEmpty(searchedTerm)) {
    return null
  }

  const parser = new DOMParser()
  const doc: Document = parser.parseFromString(searchedTerm.text, "text/html")
  const link = doc.querySelector("a")?.getAttribute("href")

  if (isEmpty(link)) {
    return null
  }

  return (
    <UnderlineLinkAtm
      typography={typography || "medium1_h"}
      title={title}
      href={link}
      emphasis={emphasis}
      openInNewTab
    >
      {text}
    </UnderlineLinkAtm>
  )
}

export default TermLink
